import { colorsList } from "../../data/colorsList";

export default function HistoryTableBody({ lapsus, data }) {
  return (
    <tbody>
      <tr style={{ height: 20 }}>
        {lapsus.map((v, index) => (
          <td key={index} style={{ position: "relative" }}>
            {data["m" + v.pos] &&
              data["m" + v.pos].map((n, index) => (
                <div
                  key={index}
                  style={{
                    position: "absolute",
                    left: n[0].POS + "%",
                    height: 20,
                    backgroundColor:
                      n.length === 1 && n[0].STA === 3
                        ? colorsList.green
                        : colorsList.red,
                    width: "6%",
                    top: 0,
                  }}
                />
              ))}
          </td>
        ))}
      </tr>
    </tbody>
  );
}
